// --------------------------------------------------------------
// Created On: 2024-05-08
// Author: KC Willard
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./DotLoader.module.scss";

// A bouncing dot loading component.
export default function DotLoader(props: Props): Component {
  return props.loading ? (
    <div className={`${styles.dotLoader} ${props.isLarge ? styles.dotLoaderLarge : ""} ${props.className}`}>
      <div />
      <div />
      <div />
      {props.isLarge && <div />}
    </div>
  ) : null;
}

interface Props {
  loading: boolean;
  className: string;
  isLarge?: boolean;
}
